import { saveBlobAsFile } from './saveBlobAsFile'

// eslint-disable-next-line import/prefer-default-export
export async function saveUrlAsFile(url: string, filename: string | null | undefined): Promise<void> {
  const response = await fetch(url, { cache: 'no-cache' })
  if (!response.ok) {
    throw new Error(`File download failed with status ${response.status}`)
  }
  saveBlobAsFile(await response.blob(), filename)
}
